/**
 * @module Services/Bff/Presenters/Request/Cart
 * @desc Cart Request Presenter
 *
 */

import { hasPayload } from './utilities';

import type { CartItemBase } from 'core/domains';
import type { CartItemUpdateRequestOptions } from 'core/services/bff/@types';

/**
 * Transforms the cart item update request payload from the domain to the request options
 *
 */
export function cartItemUpdatePresenter(payload: undefined | CartItemBase) {
  if (!hasPayload(payload)) {
    return;
  }

  const { productCode, productPosition, productOrigin, quantity } = payload;
  const requestOptions: CartItemUpdateRequestOptions = {
    quantity,
    sku: Number(productCode),
    origin: productOrigin,
    number: productPosition,
  };

  return requestOptions;
}
